module.exports = __webpack_public_path__ + "static/img/groundabout11.94127fd6.png";